import { RequestConstants } from "@lib/titan2/dist/api/core/request/RequestConstants";
import { ServiceRequest } from "./Service";
/**
 * GameRequest.ts
 */
export class GameRequest extends ServiceRequest {
    constructor(requestData, requestUrl, requestObj) {
        GameRequest.URL = requestUrl;
        super(GameRequest.URL, requestData);
        this.dataClass = requestObj.dataClass;
        this.name = requestObj.name;
        this.Method = requestObj.Method;
    }
    getName() {
        return this.name;
    }
    getTokenMethod() {
        return RequestConstants.HEADER;
    }
    getMethod() {
        return this.Method;
    }
    getDataClass() {
        return this.dataClass;
    }
}
//# sourceMappingURL=GameRequest.js.map